"use strict";

require("core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("core-js/modules/es.object.assign.js");
var _react = _interopRequireDefault(require("react"));
var _core = require("../../core");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function cov_1pyzrzlv19() {
  var path = "/__w/code/code/js/packages/bricks/src/deprecated/UNSAFE_layout/ContentWrapper.tsx";
  var hash = "d992da4aad5baadca182458b9d0d285e03e98efa";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/deprecated/UNSAFE_layout/ContentWrapper.tsx",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 43
        },
        end: {
          line: 15,
          column: 1
        }
      },
      "1": {
        start: {
          line: 7,
          column: 2
        },
        end: {
          line: 14,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 43
          },
          end: {
            line: 6,
            column: 44
          }
        },
        loc: {
          start: {
            line: 7,
            column: 2
          },
          end: {
            line: 14,
            column: 4
          }
        },
        line: 7
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0
    },
    f: {
      "0": 0
    },
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "d992da4aad5baadca182458b9d0d285e03e98efa"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1pyzrzlv19 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1pyzrzlv19();
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/** @deprecated */
cov_1pyzrzlv19().s[0]++;
var ContentWrapper = function ContentWrapper(props) {
  cov_1pyzrzlv19().f[0]++;
  cov_1pyzrzlv19().s[1]++;
  return /*#__PURE__*/_react["default"].createElement(_core.Box, _extends({
    bg: "neutrals0",
    borderRadius: "squared",
    boxShadow: "0 0 8px rgba(15, 28, 71, 0.03)",
    mb: 4,
    _last: {
      marginBottom: 0
    }
  }, props));
};
var _default = exports["default"] = ContentWrapper;